<template>
<div>
    <!-- modal -->
    <b-modal id="noteToBeOnInvoiceFormModal" centered size="lg" no-close-on-backdrop ref="noteToBeOnInvoiceFormModal" :title=" $t('noteToBeOnInvoice.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-lg-12">
                    <b-form>
                        <label for="noteToBeOnInvoice-code-input">{{ $t('noteToBeOnInvoice.code') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('noteToBeOnInvoice.code')" rules="required">
                                <b-form-input id="noteToBeOnInvoice-code-input" v-model="code" maxlength="3" size="sm" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12 mb-1">
                    <validation-provider #default="{ errors }" :name=" $t('noteToBeOnInvoice.jurisdiction')" rules="required">
                        <label for="noteToBeOnInvoice-jurisdiction-input">{{ $t('noteToBeOnInvoice.jurisdiction') }}</label>
                        <b-form-select v-model="jurisdictionSelect" size="sm" value-field="id" text-field="name" :options="jurisdictionOption" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12 mb-1">
                        <label for="noteToBeOnInvoice-currency-input">{{ $t('noteToBeOnInvoice.currency') }}</label>
                        <b-form-select v-model="currencySelect" size="sm" value-field="id" text-field="name" :options="currencyOption" />
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <validation-provider #default="{ errors }" :name=" $t('noteToBeOnInvoice.note')" rules="required">
                        <label for="noteToBeOnInvoice-note-input">{{ $t('noteToBeOnInvoice.note') }}</label>
                        <b-form-group>
                            <b-form-textarea id="noteToBeOnInvoice-note-input" v-model="note" size="sm" maxlength="500" rows="3" :state="errors.length > 0 ? false:null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getNoteToBeOnInvoiceList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            note: '',
            code: '',
            jurisdictionSelect: 0,
            jurisdictionOption: [],
            currencySelect: 0,
            currencyOption: [],            
        }
    },
    methods: {
        showInfo(id) {
            this.$refs['noteToBeOnInvoiceFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'NoteToBeOnInvoice'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.jurisdictionOption = response.data.jurisdictionList
                    this.jurisdictionOption.splice(0, 0, this.$nullSelected('name'))
                    if (response.data.noteToBeOnInvoice.jurisdictionId > 0) {
                        this.jurisdictionSelect = response.data.noteToBeOnInvoice.jurisdictionId
                    }
                    else {
                        this.jurisdictionSelect = 0
                    }

                    this.currencyOption = response.data.currencyList
                    this.currencyOption.splice(0, 0, this.$nullSelected('name'))
                    this.currencySelect = response.data.noteToBeOnInvoice.currencyId

                    this.code = response.data.noteToBeOnInvoice.code
                    this.note = response.data.noteToBeOnInvoice.note
                } else {
                    this.$bvModal.hide('noteToBeOnInvoiceFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                code: this.code,
                note: this.note,
                jurisdictionId : this.jurisdictionSelect,
                currencyId : this.currencySelect
            }
            const controller = {
                name: 'NoteToBeOnInvoice'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('noteToBeOnInvoiceFormModal')
                            this.getNoteToBeOnInvoiceList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.jurisdictionSelect = 0
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
